const KEY = 'WEBSITE_CMS_ARTICLE_FEEDBACK';

/**
 * 反馈记录暂时维护在sessionStorage中
 */
export function getFeedbackHistory(key?: string) {
  if (!process.browser) return [];
  let history = sessionStorage.getItem(KEY);
  try {
    const res = history ? JSON.parse(history) : {};
    if (key) {
      return res[key];
    }
    return res;
  } catch (error) {
    return {};
  }
}

export function setFeedbackHistory(docId: string, feedback: string) {
  if (!process.browser) return;
  const history = getFeedbackHistory();
  history[docId] = feedback;
  sessionStorage.setItem(KEY, JSON.stringify(history));
}
